<template>
  <div>
      <!------------------------search---------------------->
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item ref="query" :model="query">
            <el-input placeholder="请输入关键字" size="35" v-model="query.key" ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item v-if="actionauth.base_warehouse_add=='true'">
              <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="createDialog = true">新增仓库</el-button>
          </el-form-item>
        </el-form>
      <!------------------------search end---------------------->

      <!------------------------add---------------------->
        <el-dialog title="新增仓库" :visible.sync="createDialog">
          <el-form ref="create" :model="create" :rules="rules" label-width="100px">
            <el-col :span="14">
              <el-form-item label="仓库名称" prop="name">
                <el-input v-model="create.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="仓库编号" prop="number">
                <el-input v-model="create.number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="负责人">
                <el-input v-model="create.contact"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item label="联系电话">
                <el-input v-model="create.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="createDialog = false">取 消</el-button>
            <el-button type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------add end---------------------->
        <el-table :data="lists" v-loading="listLoading" :default-sort = "{prop: 'number', order: 'descending'}">
          <el-table-column prop="number" label="编号" sortable width="140">
          </el-table-column>
          <el-table-column prop="name" label="名称">
          </el-table-column>
          <el-table-column prop="contact" label="负责人" width="180">
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" width="180">
          </el-table-column>
          <el-table-column label="操作" width="150" v-if="actionauth.base_warehouse_edit=='true' || actionauth.base_warehouse_del=='true'">
	          <template slot-scope="scope">
	              <el-button type="primary" size="mini" icon="el-icon-edit" @click="editCurrent(scope.row)" v-if="actionauth.base_warehouse_edit=='true'"></el-button>
	              <el-button type="danger" size="mini" icon="el-icon-delete" @click="delCurrent(scope.row)" v-if="actionauth.base_warehouse_del=='true'"></el-button>
	          </template>
          </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="pageCurrentChange"
            :current-page="query.p"
            :page-sizes="[10, 20, 50]"
            :page-size="query.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>

      <!------------------------edit---------------------->
        <el-dialog title="编辑仓库信息" :visible.sync="updateDialog">
          <el-form ref="update" :model="update" :rules="rules" label-width="100px">
            <el-col :span="24">
              <el-col :span="14">
                <el-form-item label="仓库名称" prop="name">
                  <el-input v-model="update.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="仓库编号" prop="number">
                  <el-input v-model="update.number"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="10">
                <el-form-item label="负责人">
                  <el-input v-model="update.contact"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="13">
                <el-form-item label="联系电话">
                  <el-input v-model="update.phone"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="updateDialog = false">取 消</el-button>
            <el-button type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------edit end---------------------->
  </div>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //功能权限
      url:this.GLOBAL.domain+"Ware/index",
      lists:[],
      listLoading:false,
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_rows: 0,
      createDialog: false,
      createLoading: false,
      create: {
        act:'add',
        token:this.$cookies.get('token'),
        name:'',
        number:'',
        contact:'',
        phone:''
      },
      updateDialog:false,
      updateLoading:false,
      update: {
        act:'edit',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
        number:'',
        contact:'',
        phone:''
      },
      rules: {
        name: [
            { required: true, message: '请输入仓库名称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符'}
        ],
        number: [
            { required: true, message: '请输入编号', trigger: 'blur' },
            { min: 1, max: 8, message: '长度在 1 到 8 个字符'},
            { pattern:/^[A-Za-z0-9]+$/, message: '编号只能为字母和数字'}
        ]
      }
    }
  },
  mounted(){
    this.getactionauth();
    this.getList();
  },
  methods:{
    
    /** 获取功能操作权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
  
    //重置表单
    reset() {
        this.$refs.create.resetFields();
    },
    //新增
    createSave(){
      // 主动校验
      this.$refs.create.validate((valid) => {
          if (valid) {
              this.createLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.create).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.createLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.createDialog=false;
                    this.createLoading=false;
                    this.reset();
                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createDialog=false;
                  this.createLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    //信息列表
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    //编辑
    editCurrent(item){
        this.update.id=item.id
        this.update.name=item.name
        this.update.number=item.number
        this.update.contact=item.contact
        this.update.phone=item.phone
        this.updateDialog=true;
    },
    //更新
    updateSave(){
      // 主动校验
      this.$refs.update.validate((valid) => {
          if (valid) {
              this.updateLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.update).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.updateLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateDialog=false;
                    this.updateLoading=false;
                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.updateDialog=false;
                  this.updateLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    //删除
    delCurrent(item){
      this.$confirm('此操作将删除 [' + item.name + '] 所有库存, 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.name + '!');
                    this.getList();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventory/Warespace.vue